/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import dayjs from 'dayjs';

export interface IConceptDataType {
  id?: string;
  description?: string | null;
  hl7Abbreviation?: string | null;
  uuid?: string | null;
  name?: string | null;
  cursor?: number;
  active?: boolean;
  created?: dayjs.Dayjs | null;
  microSec?: number;
  timestampentry?: number;
  lastupdated?: number;
}

export const defaultValue: Readonly<IConceptDataType> = {
  active: false,
};
